import PairButtons, {
  PairButton,
  PairButtonsProps,
} from "features/bots/BotForm/General/PairButtons.tsx";
import React, { ChangeEvent } from "react";
import { useSearchInput } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/hooks.ts";
import SearchOutlined from "@ant-design/icons/SearchOutlined";
import styled, { useTheme } from "styled-components";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import Input from "common/Inputs/Input.tsx";
import useAutoSizeInput from "common/Inputs/useAutoSizeInput.tsx";

const PairButtonsWithSearch = (props: PairButtonsProps) => {
  const {
    isSearchOpen,
    onChange,
    onCloseSearch,
    onOpenSearchClick,
    searchInputRef,
    hide,
    value,
  } = useSearchInput();
  const theme = useTheme();
  useAutoSizeInput(() => searchInputRef.current?.input, 45);

  const getTagContent = () => {
    if (isSearchOpen) {
      return (
        <SearchInput
          ref={searchInputRef}
          suffix={<CloseOutlined onClick={onCloseSearch} />}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
          onBlur={() => {
            if (!value) onCloseSearch();
          }}
          value={value}
        />
      );
    } else {
      return (
        <SearchOutlined
          style={{ color: theme.colors.primaryText, fontSize: 16 }}
          onClick={onOpenSearchClick}
        />
      );
    }
  };

  const getSearchTag = () => {
    if (hide) return;
    return (
      <PairButton
        key="search"
        onClick={isSearchOpen ? undefined : onOpenSearchClick}
        style={{ height: 32, minWidth: 38 }}
      >
        {getTagContent()}
      </PairButton>
    );
  };

  return <PairButtons {...props} extraTag={getSearchTag()} />;
};

export default PairButtonsWithSearch;

const SearchInput = styled(Input)`
  width: min-content;
  max-width: 160px;
  font-size: ${(p) => p.theme.typography.fontSizes.S};
  box-shadow: none !important;
  border-bottom: ${(p) => p.theme.borders.medium} !important;
  border-style: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  padding: 0;
  &&& {
    .ant-input {
      background: transparent !important;
      transition: none;
    }
  }
`;
